var BfAuthJwtHelper = /** @class */ (function () {
    function BfAuthJwtHelper() {
    }
    /**
     * decode a jwt token
     * @param token
     * @returns decoded jwt token
     */
    BfAuthJwtHelper.decodeToken = function (token) {
        if (token == null)
            return null;
        var parts = token.split('.');
        if (parts.length !== 3)
            throw new Error('JWT must have 3 parts');
        var output = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
            case 0: break;
            case 2:
                output += '==';
                break;
            case 3:
                output += '=';
                break;
            default: throw 'Illegal base64url string!';
        }
        var decoded = this.b64DecodeUnicode(output);
        if (!decoded)
            throw new Error('Cannot decode the token');
        var result = JSON.parse(decoded);
        return result;
    };
    /**
     * base 64 encode unicode string
     * from original string, to percent-encoding, to bytestream, to encoded string
     * reference: https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
     * @param stringToEncode
     * @returns encoded string
     */
    BfAuthJwtHelper.b64EncodeUnicode = function (stringToEncode) {
        // 1. first we use encodeURIComponent to get percent-encoded UTF-8,
        var percentEncodedUTF8 = encodeURIComponent(stringToEncode);
        // 2. then we convert the percent encodings into raw bytes which
        var rawBytes = percentEncodedUTF8.replace(/%([0-9A-F]{2})/g, function (substring, p1) { return String.fromCharCode(+'0x', p1); });
        // 3. encode rayBytes.
        var encodedSting = btoa(rawBytes);
        return encodedSting;
    };
    /**
     * base 64 decode unicode string
     * from encode string, to bytestream, to percent-encoding, to original string
     * reference: https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
     * @param stringToDecode
     * @returns decoded string
     */
    BfAuthJwtHelper.b64DecodeUnicode = function (stringToDecode) {
        // 1. decode string.
        var decodedSting = atob(stringToDecode);
        // 2. then we convert decoded string to rayBytes
        var rawBytes = decodedSting
            .split('')
            .map(function (c) { return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2); })
            .join('');
        // 3. then we convert rayBytes to to percent encodings
        var percentDecodedUTF8 = decodeURIComponent(rawBytes);
        return percentDecodedUTF8;
    };
    BfAuthJwtHelper.expirationDate = function (token) {
        var decoded = this.decodeToken(token);
        if (decoded == null || !decoded.hasOwnProperty('exp'))
            return null;
        var date = new Date(0);
        date.setUTCSeconds(decoded.exp);
        return date;
    };
    BfAuthJwtHelper.isTokenExpired = function (token, offsetSeconds) {
        var date = this.expirationDate(token);
        offsetSeconds = offsetSeconds || 0;
        if (date === null) {
            return true;
        }
        return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
    };
    return BfAuthJwtHelper;
}());
export { BfAuthJwtHelper };
